import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import config from "../../envconfig";
import { UserContext } from "../common/UserContext";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

// Define phone number lengths for different country codes (same as UM)
const phoneNumberLengths = {
  "+1": 10, "+7": 10, "+20": 10, "+27": 9, "+30": 10, "+31": 9, "+32": 9, "+33": 9, "+34": 9,
  "+36": 9, "+39": 10, "+40": 10, "+41": 9, "+43": 10, "+44": 10, "+45": 8, "+46": 9, "+47": 8,
  "+48": 9, "+49": 11, "+51": 9, "+52": 10, "+53": 8, "+54": 10, "+55": 10, "+56": 9, "+57": 10,
  "+58": 10, "+60": 9, "+61": 9, "+62": 9, "+63": 9, "+64": 9, "+65": 8, "+66": 9, "+81": 10,
  "+82": 9, "+84": 9, "+86": 11, "+90": 10, "+91": 10, "+92": 10, "+93": 9, "+94": 9, "+95": 9,
  "+98": 10, "+211": 9, "+212": 9, "+213": 9, "+216": 8, "+218": 9, "+220": 7, "+221": 9, "+222": 9,
  "+223": 8, "+224": 9, "+225": 10, "+226": 8, "+227": 8, "+228": 8, "+229": 8, "+230": 8, "+231": 8,
  "+232": 8, "+233": 9, "+234": 10, "+235": 8, "+236": 8, "+237": 9, "+238": 7, "+239": 7, "+240": 9,
  "+241": 9, "+242": 9, "+243": 9, "+244": 9, "+245": 7, "+246": 8, "+248": 7, "+249": 9, "+250": 9,
  "+251": 9, "+252": 9, "+253": 8, "+254": 9, "+255": 9, "+256": 9, "+257": 8, "+258": 9, "+260": 9,
  "+261": 9, "+262": 9, "+263": 9, "+264": 9, "+265": 9, "+266": 8, "+267": 8, "+268": 8, "+269": 7,
  "+290": 7, "+291": 7, "+297": 7, "+298": 6, "+299": 6, "+350": 8, "+351": 9, "+352": 9, "+353": 9,
  "+354": 7, "+355": 9, "+356": 8, "+357": 8, "+358": 10, "+359": 9, "+370": 8, "+371": 8, "+372": 8,
  "+373": 8, "+374": 8, "+375": 9, "+376": 6, "+377": 8, "+378": 10, "+379": 9, "+380": 9, "+381": 9,
  "+382": 8, "+383": 8, "+385": 9, "+386": 8, "+387": 8, "+389": 8, "+420": 9, "+421": 9, "+423": 7, '+971': 9,
};

// Define options for Location Type dropdown
const locationTypeOptions = [
  { value: "Warehouse", label: "Warehouse" },
  { value: "Plant", label: "Plant" },
  { value: "SCP", label: "SCP" }
];

// Define options for Shipping Country Code dropdown
const shippingCountryCodeOptions = [
  { value: "IND", label: "IND" },
  { value: "USA", label: "USA" }
];

// Define options for Status dropdown
const statusOptions = [
  { value: 1, label: "Active" },
  { value: 2, label: "Inactive" }
];

function LocationMasterEdit() {
  const {
    UM_GroupId,
    UM_CompanyGrpID,
    selectedScpId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    UM_DefaultSCPId,
    UM_UserType
  } = useContext(UserContext);
  console.log("UM_UserType", UM_UserType)
  const [olddata, setolddata] = useState([]);
  const { LCM_ID } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const toastRef = useRef(null);
  const showToast = (type, message, options = {}) => {
    if (toastRef.current && toast.isActive(toastRef.current)) {
      toast.update(toastRef.current, {
        render: message,
        type,
        autoClose: 3000,
        ...options,
      });
    } else {
      toastRef.current = toast[type](message, {
        autoClose: 3000,
        ...options,
      });
    }
  };
  // THIS API IS USED TO PRINT THE LOG IN DRIVE D IN LOG FOLDER
  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "Location Master:",
          action,
          userCode: UM_UserCode,
          isError,
        }),
      });
      if (!response.ok) {
        throw new Error("Failed to log action");
      }
    } catch (error) {
      console.error("Error logging action:", error);
    }
  };

  useEffect(() => {
    sessionStorage.setItem("UM_GroupId", UM_GroupId);
    sessionStorage.setItem("UM_CompanyGrpID", UM_CompanyGrpID);
    sessionStorage.setItem("UM_DefaultSCPId", UM_DefaultSCPId);
    sessionStorage.setItem("UM_CompanyID", UM_CompanyID);
    sessionStorage.setItem("UM_UserId", UM_UserId);
    sessionStorage.setItem("UM_UserCode", UM_UserCode);
    sessionStorage.setItem("selectedScpId", selectedScpId);
    sessionStorage.setItem("UM_UserType", UM_UserType);
  }, [
    UM_GroupId,
    UM_CompanyGrpID,
    UM_DefaultSCPId,
    UM_CompanyID,
    UM_UserId,
    UM_UserCode,
    selectedScpId,
    UM_UserType
  ]);
  // TILL HERE
  const audittrailpost = async (details) => {
    const getCurrentTimestamp = () => {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // months are zero-indexed
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const currentTimestamp = getCurrentTimestamp();
    const AUTR_OldValue = details?.AUTR_OldValue ?? null;
    const AUTR_NewValue = details?.AUTR_NewValue ?? null;
    const AUTR_Message = details.AUTR_Message;
    const AUTR_AuditType = details.AUTR_AuditType;

    const data = {
      AUTR_ScreenName: "Location Master",
      AUTR_OldValue: AUTR_OldValue,
      AUTR_NewValue: AUTR_NewValue,
      AUTR_Message: AUTR_Message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_TimeStamp: currentTimestamp,
      AUTR_AuditType: AUTR_AuditType,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      AUTR_CreatedDateTime: currentTimestamp,
    };

    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittrail`,
        data
      );
      console.log("Success:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const [LocMEdit, setLOCEdit] = useState({
    LCM_LocationName: "",
    LCM_LocationCode: "",
    LCM_Type: "",
    LCM_CompanyID: UM_CompanyID,
    LCM_SCPID: parseInt(UM_UserType) === 1 ? "" : selectedScpId,
    LCM_LocationStreet1: "",
    LCM_LocationStreet2: "",
    LCM_PostalCode: "",
    LCM_City: "",
    LCM_State: "",
    LCM_Country: "",
    LCM_ShippingCountryCode: "",
    LCM_District: "",
    LCM_EmailID: "",
    LCM_ContactNumber: "",
    LCM_ContactCountryCode: "+91", // Add country code field for phone
    LCM_GLN: "",
    LCM_SGLN: "",
    LCM_Latitude: "",
    LCM_Longitude: "",
    LCM_CompanyEmailID: "",
    LCM_URL: "",
    LCM_LabelAddress1: "",
    LCM_LabelAddress2: "",
    LCM_LabelAddress3: "",
    LCM_LabelAddress4: "",
    LCM_LabelAddress5: "",
    LCM_Status: 1,
    LCM_CompanyGrpId: UM_CompanyGrpID,
  });

  const [errors, setErrors] = useState({
    required: {
      LCM_LocationName: "",
      LCM_LocationCode: "",
      LCM_Type: "",
      LCM_SCPID: "",
      LCM_LocationStreet1: "",
      LCM_LocationStreet2: "",
      LCM_PostalCode: "",
      LCM_City: "",
      LCM_State: "",
      LCM_Country: "",
      LCM_ShippingCountryCode: "",
      LCM_District: "",
      LCM_EmailID: "",
      LCM_ContactNumber: "",
      LCM_GLN: "",
      LCM_SGLN: "",
      LCM_Latitude: "",
      LCM_Longitude: "",
      LCM_CompanyEmailID: "",
      LCM_URL: "",
      LCM_LabelAddress1: "",
      LCM_LabelAddress2: "",
      LCM_LabelAddress3: "",
      LCM_LabelAddress4: "",
      LCM_LabelAddress5: "",
      LCM_Status: "",
    },
    other: {
      LCM_LocationName: "",
      LCM_LocationCode: "",
      LCM_Type: "",
      LCM_SCPID: "",
      LCM_LocationStreet1: "",
      LCM_LocationStreet2: "",
      LCM_PostalCode: "",
      LCM_City: "",
      LCM_State: "",
      LCM_Country: "",
      LCM_ShippingCountryCode: "",
      LCM_District: "",
      LCM_EmailID: "",
      LCM_ContactNumber: "",
      LCM_GLN: "",
      LCM_SGLN: "",
      LCM_Latitude: "",
      LCM_Longitude: "",
      LCM_CompanyEmailID: "",
      LCM_URL: "",
      LCM_LabelAddress1: "",
      LCM_LabelAddress2: "",
      LCM_LabelAddress3: "",
      LCM_LabelAddress4: "",
      LCM_LabelAddress5: "",
      LCM_Status: "",
    },
  });

  const [message, setMessage] = useState("");
  // Inside the component, add these state variables after the existing states:
  const [scpOptions, setScpOptions] = useState([]);
  const [selectedScpOption, setSelectedScpOption] = useState(null);
  const [loadingScps, setLoadingScps] = useState(false);
  const [phoneResetKey, setPhoneResetKey] = useState(0); // Add reset key for PhoneInput

  // States for react-select dropdowns
  const [selectedLocationType, setSelectedLocationType] = useState(null);
  const [selectedShippingCountryCode, setSelectedShippingCountryCode] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);

  useEffect(() => {
    // Function to fetch SCP data (only for UserType 1)
    const fetchScpData = async () => {
      if (parseInt(UM_UserType) === 1) {
        try {
          setLoadingScps(true);
          const response = await axios.get(`${config.API_URL}/scps/${UM_CompanyID}`);

          if (response.data.success) {
            const options = response.data.data.map(scp => ({
              value: scp.SCPM_ID,
              label: scp.SCPM_Name
            }));
            setScpOptions(options);
            console.log("scp options in edit======", options);
          } else {
            console.error("Failed to fetch SCP data:", response.data.message);
            showToast('error', "Failed to load SCP options");
          }
        } catch (error) {
          console.error("Error fetching SCP data:", error);
          showToast('error', "Error loading SCP options");
        } finally {
          setLoadingScps(false);
        }
      }
    };

    fetchScpData();
  }, [UM_CompanyID, UM_UserType]);

  useEffect(() => {
    // Set selected SCP option when LocMEdit data is loaded
    if (parseInt(UM_UserType) === 1 && LocMEdit.LCM_SCPID && scpOptions.length > 0) {
      const selectedOption = scpOptions.find(option =>
        option.value === LocMEdit.LCM_SCPID ||
        option.value === parseInt(LocMEdit.LCM_SCPID)
      );
      if (selectedOption) {
        setSelectedScpOption(selectedOption);
        console.log("selectedOption-------------------------", selectedOption);
      }
    }
  }, [LocMEdit.LCM_SCPID, scpOptions, UM_UserType]);

  // Handle Location Type change
  const handleLocationTypeChange = (selectedOption) => {
    setSelectedLocationType(selectedOption);

    setLOCEdit(prev => ({
      ...prev,
      LCM_Type: selectedOption ? selectedOption.value : ""
    }));

    setErrors(prev => ({
      ...prev,
      required: {
        ...prev.required,
        LCM_Type: selectedOption ? "" : "*"
      }
    }));
  };


  // Handle Shipping Country Code change
  const handleShippingCountryCodeChange = (selectedOption) => {
    setSelectedShippingCountryCode(selectedOption);

    setLOCEdit(prev => ({
      ...prev,
      LCM_ShippingCountryCode: selectedOption ? selectedOption.value : ""
    }));

    setErrors(prev => ({
      ...prev,
      required: {
        ...prev.required,
        LCM_ShippingCountryCode: selectedOption ? "" : "*"
      }
    }));
  };


  // Handle Status change
  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);

    if (selectedOption) {
      setLOCEdit(prev => ({
        ...prev,
        LCM_Status: selectedOption.value
      }));
    } else {
      setLOCEdit(prev => ({
        ...prev,
        LCM_Status: ""
      }));
    }
  };

  // Handle SCP selection change
  const handleScpChange = (selectedOption) => {
    setSelectedScpOption(selectedOption);

    setLOCEdit(prev => ({
      ...prev,
      LCM_SCPID: selectedOption ? selectedOption.value : ""
    }));

    setErrors(prev => ({
      ...prev,
      required: {
        ...prev.required,
        LCM_SCPID: selectedOption ? "" : "*"
      }
    }));
  };


  // Function to detect country code from phone number (similar to UMEdit)
  const detectCountryCode = (phoneNumber) => {
    if (!phoneNumber) return "+91";

    const numericPhone = phoneNumber.replace(/\D/g, "");
    const sortedCodes = Object.keys(phoneNumberLengths).sort((a, b) => b.length - a.length);

    for (const code of sortedCodes) {
      const numericCode = code.replace("+", "");
      if (numericPhone.startsWith(numericCode)) {
        return code;
      }
    }
    return "+91";
  };

  // Phone validation function (same as UMEdit)
  const validatePhone = (value, countryCode = LocMEdit.LCM_ContactCountryCode) => {
    const newErrors = { ...errors };

    // If the phone field is empty, clear any existing errors and skip validation
    if (!value || value.trim() === '') {
      newErrors.required.LCM_ContactNumber = '';
      newErrors.other.LCM_ContactNumber = '';
      setErrors(newErrors);
      return;
    }

    // Proceed with validation if phone field has a value
    newErrors.required.LCM_ContactNumber = '';

    const fullPhoneNumber = value.trim();
    const numericPhoneNumber = fullPhoneNumber.replace(/\D/g, '');
    let localPhoneNumber = numericPhoneNumber;
    const countryCodeDigits = countryCode.replace('+', '');

    if (numericPhoneNumber.startsWith(countryCodeDigits)) {
      localPhoneNumber = numericPhoneNumber.substring(countryCodeDigits.length);
    }

    // Check if phone number starts with 0
    if (localPhoneNumber.startsWith('0')) {
      newErrors.other.LCM_ContactNumber = 'Phone Number cannot start with 0';
      logAction('Phone validation: number starts with 0', true);
      setErrors(newErrors);
      return;
    }

    const expectedLength = phoneNumberLengths[countryCode] || 10;

    if (!new RegExp(`^\\d{${expectedLength}}$`).test(localPhoneNumber)) {
      newErrors.other.LCM_ContactNumber = `Phone Number must be ${expectedLength} digits for ${countryCode}`;
      logAction(`Phone validation: must be ${expectedLength} digits for ${countryCode}`, true);
    } else {
      newErrors.other.LCM_ContactNumber = '';
    }

    setErrors(newErrors);
  };

  // Phone input change handler (similar to UMEdit)
  const handlePhoneChange = (phone, country) => {
    logAction(`Phone number changed to ${phone} (country: ${country.name})`);

    if (!phone) {
      setLOCEdit(prev => ({
        ...prev,
        LCM_ContactNumber: '',
        LCM_ContactCountryCode: '+91'
      }));
      return;
    }

    setLOCEdit(prev => ({
      ...prev,
      LCM_ContactNumber: phone,
      LCM_ContactCountryCode: country ? `+${country.dialCode}` : '+91'
    }));

    validatePhone(phone, country ? `+${country.dialCode}` : '+91');
  };

  //LCMEdit
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${config.API_URL}/LocationMasterEdit/${LCM_ID}`
        );
        if (response.ok) {
          const data = await response.json();
          const old = {
            LCM_LocationName: data.LCM_LocationName,
            LCM_LocationCode: data.LCM_LocationCode,
            LCM_Type: data.LCM_Type,
            LCM_SCPID: data.LCM_SCPID,
            LCM_LocationStreet1: data.LCM_LocationStreet1,
            LCM_LocationStreet2: data.LCM_LocationStreet2,
            LCM_PostalCode: data.LCM_PostalCode,
            LCM_City: data.LCM_City,
            LCM_State: data.LCM_State,
            LCM_Country: data.LCM_Country,
            LCM_ShippingCountryCode: data.LCM_ShippingCountryCode,
            LCM_District: data.LCM_District,
            LCM_EmailID: data.LCM_EmailID,
            LCM_ContactNumber: data.LCM_ContactNumber,
            LCM_GLN: data.LCM_GLN,
            LCM_SGLN: data.LCM_SGLN,
            LCM_Latitude: data.LCM_Latitude,
            LCM_Longitude: data.LCM_Longitude,
            LCM_CompanyEmailID: data.LCM_CompanyEmailID,
            LCM_URL: data.LCM_URL,
            LCM_LabelAddress1: data.LCM_LabelAddress1,
            LCM_LabelAddress2: data.LCM_LabelAddress2,
            LCM_LabelAddress3: data.LCM_LabelAddress3,
            LCM_LabelAddress4: data.LCM_LabelAddress4,
            LCM_LabelAddress5: data.LCM_LabelAddress5,
            LCM_Status: data.LCM_Status,
          };
          setolddata(old);

          // Detect country code from phone number
          const detectedCode = detectCountryCode(String(data.LCM_ContactNumber || ""));

          // Set dropdown values based on fetched data
          const locationTypeOption = locationTypeOptions.find(option => option.value === data.LCM_Type);
          const shippingCountryOption = shippingCountryCodeOptions.find(option => option.value === data.LCM_ShippingCountryCode);
          const statusOption = statusOptions.find(option => option.value === data.LCM_Status);

          setSelectedLocationType(locationTypeOption || null);
          setSelectedShippingCountryCode(shippingCountryOption || null);
          setSelectedStatus(statusOption || null);

          setLOCEdit({
            ...data,
            LCM_ContactCountryCode: detectedCode
          });
        } else {
          console.error("Error fetching the data");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData(); // Call the fetchData function immediately
  }, [LCM_ID]); // Empty dependency array to run once when component mounts

  const validateField = (
    field,
    value,
    pattern,
    errorMsg,
    lengthCheck = true
  ) => {
    let error = "";
    if (!value) {
      error = "*";
    } else if (!pattern.test(value)) {
      error = errorMsg;
    } else if (lengthCheck && value.length > 45) {
      error = "Maximum length is 45 characters.";
    } else if (
      !/^[a-zA-Z0-9]/.test(value[0]) ||
      !/^[a-zA-Z0-9]/.test(value.slice(-1))
    ) {
      error = "First and last character must be alphanumeric";
    } else if (/[_@.]{2,}/.test(value)) {
      error = "Consecutive underscore, dot, and @ are not allowed";
    }
    return error;
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };
    logAction("validateForm():Started");

    if (!LocMEdit.LCM_LocationName) {
      newErrors.required.LCM_LocationName = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]$/.test(LocMEdit.LCM_LocationName[0]) ||
      !/^[a-zA-Z0-9]$/.test(LocMEdit.LCM_LocationName.slice(-1))
    ) {
      newErrors.other.LCM_LocationName =
        "First and last character must be alphanumeric";
      valid = false;
      logAction(
        "validateForm(): First and last character must be alphanumeric",
        true
      );
    } else if (!/^[a-zA-Z0-9_.,/ -]+$/.test(LocMEdit.LCM_LocationName)) {
      newErrors.other.LCM_LocationName =
        "Please use only allowed special characters like . , / , - and _";
      valid = false;
      logAction(
        "validateForm(): Please use only allowed special characters like . , / , - and _",
        true
      );
    } else if (
      /([_.,/ -])\1/.test(LocMEdit.LCM_LocationName)
    ) {
      newErrors.other.LCM_LocationName =
        "Consecutive special characters are not allowed";
      valid = false;
      logAction(
        "validateForm(): Consecutive special characters are not allowed",
        true
      );
    } else if (LocMEdit.LCM_LocationName.length > 45) {
      newErrors.other.LCM_LocationName = "Maximum length is 45 characters.";
      valid = false;
      logAction("validateForm(): Maximum length is 45 characters.", true);
    } else {
      newErrors.required.LCM_LocationName = "";
      newErrors.other.LCM_LocationName = "";
    }

    // Validate LCM_LocationCode
    if (!LocMEdit.LCM_LocationCode) {
      newErrors.required.LCM_LocationCode = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]/.test(LocMEdit.LCM_LocationCode[0]) ||
      !/[a-zA-Z0-9]$/.test(LocMEdit.LCM_LocationCode)
    ) {
      newErrors.other.LCM_LocationCode =
        "First and last character must be alphanumeric";
      valid = false;
      logAction(
        "validateForm(): First and last character must be alphanumeric",
        true
      );
    } else if (!/^[a-zA-Z0-9_ -\s]+$/.test(LocMEdit.LCM_LocationCode)) {
      newErrors.other.LCM_LocationCode =
        "Please use only special characters like, - and _";
      valid = false;
      logAction(
        "validateForm(): Please use only special characters like, - and _",
        true
      );

    } else if (/[_ -]{2,}/.test(LocMEdit.LCM_LocationCode)) {
      newErrors.other.LCM_LocationCode =
        "Consecutive special characters are not allowed.";
      valid = false;
      logAction(
        "validateForm(): Consecutive special characters are not allowed.",
        true
      );
    } else if (LocMEdit.LCM_LocationCode.length > 45) {
      newErrors.other.LCM_LocationCode = "Maximum length is 45 characters.";
      valid = false;
      logAction("validateForm(): Maximum length is 45 characters.", true);
    } else {
      newErrors.required.LCM_LocationCode = "";
      newErrors.other.LCM_LocationCode = "";
    }

    // Add validation for LCM_SCPID when UM_UserType is 1
    if (parseInt(UM_UserType) === 1 && !LocMEdit.LCM_SCPID) {
      newErrors.required.LCM_SCPID = "*";
      valid = false;
    } else if (parseInt(UM_UserType) === 1) {
      newErrors.required.LCM_SCPID = "";
    }

    // Validate LCM_Type
    if (!LocMEdit.LCM_Type) {
      newErrors.required.LCM_Type = "*";
      valid = false;
    } else {
      newErrors.required.LCM_Type = "";
      newErrors.other.LCM_Type = "";
    }

    // Validate LCM_PostalCode
    if (!LocMEdit.LCM_PostalCode) {
      newErrors.required.LCM_PostalCode = "*";
      valid = false;
    } else if (
      !/^[a-zA-Z0-9]/.test(LocMEdit.LCM_PostalCode[0]) ||
      !/[a-zA-Z0-9]$/.test(LocMEdit.LCM_PostalCode)
    ) {
      newErrors.other.LCM_PostalCode =
        "First and last character must be alphanumeric";
      valid = false;
      logAction(
        "validateForm(): First and last character must be alphanumeric",
        true
      );
    } else if (!/^[a-zA-Z0-9-\s]+$/.test(LocMEdit.LCM_PostalCode)) {
      newErrors.other.LCM_PostalCode =
        "Please use only alphanumeric characters, spaces and -";
      valid = false;
      logAction(
        "validateForm(): Please use only alphanumeric characters, spaces and -",
        true
      );
    } else if (/[- ]{2,}/.test(LocMEdit.LCM_PostalCode)) {
      newErrors.other.LCM_PostalCode = "Consecutive special characters are not allowed";
      valid = false;
      logAction("validateForm(): Consecutive special characters are not allowed", true);
    } else if (LocMEdit.LCM_PostalCode.length > 45) {
      newErrors.other.LCM_PostalCode = "Maximum length is 45 characters.";
      valid = false;
      logAction("validateForm(): Maximum length is 45 characters.", true);
    } else {
      newErrors.required.LCM_PostalCode = "";
      newErrors.other.LCM_PostalCode = "";
    }

    // Validate LCM_City
    if (!LocMEdit.LCM_City) {
      newErrors.required.LCM_City = "*";
      valid = false;
    } else if (!/^[a-zA-Z\s]*$/.test(LocMEdit.LCM_City)) {
      newErrors.other.LCM_City = "Only alphabets are allowed";
      valid = false;
      logAction("validateForm():Only alphabets are allowed", true);
    } else {
      newErrors.required.LCM_City = "";
      newErrors.other.LCM_City = "";
    }

    // Validate LCM_State
    if (!LocMEdit.LCM_State) {
      newErrors.required.LCM_State = "*";
      valid = false;
    } else if (!/^[a-zA-Z\s]*$/.test(LocMEdit.LCM_State)) {
      newErrors.other.LCM_State = "Only alphabets are allowed";
      valid = false;
      logAction("validateForm():Only alphabets are allowed", true);
    } else {
      newErrors.required.LCM_State = "";
      newErrors.other.LCM_State = "";
    }

    // Validate LCM_Country
    if (!LocMEdit.LCM_Country) {
      newErrors.required.LCM_Country = "*";
      valid = false;
    } else if (!/^[a-zA-Z\s]*$/.test(LocMEdit.LCM_Country)) {
      newErrors.other.LCM_Country = "Only alphabets are allowed";
      valid = false;
      logAction("validateForm():Only alphabets are allowed", true);
    } else {
      newErrors.required.LCM_Country = "";
      newErrors.other.LCM_Country = "";
    }

    // Validate LCM_ShippingCountryCode
    if (!LocMEdit.LCM_ShippingCountryCode) {
      newErrors.required.LCM_ShippingCountryCode = "*";
      valid = false;
    } else {
      newErrors.required.LCM_ShippingCountryCode = "";
      newErrors.other.LCM_ShippingCountryCode = "";
    }

    // Validate LCM_District
    if (!/^[a-zA-Z\s]*$/.test(LocMEdit.LCM_District)) {
      newErrors.other.LCM_District = "Only alphabets are allowed";
      valid = false;
      logAction("validateForm():Only alphabets are allowed", true);
    } else {
      newErrors.required.LCM_District = "";
      newErrors.other.LCM_District = "";
    }

    // Validate LCM_EmailID
    // // Validate LCM_EmailID
    // if (LocMEdit.LCM_EmailID) {
    //   // Updated regex to prevent dots in wrong positions
    //   if (!/^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9]+([.-][a-z0-9]+)*\.[a-z]{2,}$/.test(LocMEdit.LCM_EmailID.toLowerCase())) {
    //     newErrors.other.LCM_EmailID = "Invalid email format";
    //     valid = false;
    //     logAction("validateForm(): Invalid email format", true);
    //   } else {
    //     newErrors.required.LCM_EmailID = "";
    //     newErrors.other.LCM_EmailID = "";
    //   }
    // } else {
    //   newErrors.required.LCM_EmailID = "";
    //   newErrors.other.LCM_EmailID = "";
    // }

    // Validate LCM_EmailID
    if (LocMEdit.LCM_EmailID) {

      const email = LocMEdit.LCM_EmailID.trim().toLowerCase();
      const emailRegex = /^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}(\.[a-z]{2,})?$/;

      // ✅ Length check
      if (email.length > 45) {
        newErrors.other.LCM_EmailID = "Email must not exceed 45 characters";
        valid = false;
        logAction("validateForm(): Email length exceeded", true);
      }

      // ✅ Format check
      else if (!emailRegex.test(email)) {
        newErrors.other.LCM_EmailID = "Invalid email format";
        valid = false;
        logAction("validateForm(): Invalid email format", true);
      }

      else {
        newErrors.required.LCM_EmailID = "";
        newErrors.other.LCM_EmailID = "";
      }

    } else {
      newErrors.required.LCM_EmailID = "";
      newErrors.other.LCM_EmailID = "";
    }


    // Phone validation (same as UMEdit)
    if (LocMEdit.LCM_ContactNumber) {
      const phoneNumber = LocMEdit.LCM_ContactNumber.toString();
      const countryCode = LocMEdit.LCM_ContactCountryCode || '+91';
      const countryCodeDigits = countryCode.replace('+', '');

      // Remove country code if present
      let localNumber = phoneNumber.startsWith(countryCodeDigits)
        ? phoneNumber.substring(countryCodeDigits.length)
        : phoneNumber;

      // Remove all non-digit characters
      localNumber = localNumber.replace(/\D/g, '');

      const expectedLength = phoneNumberLengths[countryCode] || 10;

      if (localNumber.length !== expectedLength) {
        newErrors.other.LCM_ContactNumber = `Phone Number must be ${expectedLength} digits for ${countryCode}`;
        valid = false;
      } else if (localNumber.startsWith('0')) {
        newErrors.other.LCM_ContactNumber = 'Phone Number cannot start with 0';
        valid = false;
        logAction('Phone validation: number starts with 0', true);
      } else {
        newErrors.other.LCM_ContactNumber = '';
      }
    }

    //=====================================
    // Check if both are empty
    if (!LocMEdit.LCM_GLN && !LocMEdit.LCM_SGLN) {
      newErrors.required.LCM_GLN = "*";
      newErrors.required.LCM_SGLN = "*";
      valid = false;
      logAction("validateForm(): Either GLN or SGLN must be provided", true);
    } else {
      newErrors.required.LCM_GLN = "";
      newErrors.required.LCM_SGLN = "";
    }

    // Validate LCM_GLN if provided
    if (LocMEdit.LCM_GLN) {
      // Check if it contains only digits
      if (!/^\d+$/.test(LocMEdit.LCM_GLN)) {
        newErrors.other.LCM_GLN = "Only numeric digits are allowed";
        valid = false;
        logAction("validateForm(): Only numeric digits are allowed", true);
      }
      // Check if it's all zeros
      else if (/^0+$/.test(LocMEdit.LCM_GLN)) {
        newErrors.other.LCM_GLN = "Invalid GLN";
        valid = false;
        logAction("validateForm(): GLN cannot be all zeros", true);
      }
      // Check if it's only "0"
      else if (LocMEdit.LCM_GLN === "0") {
        newErrors.other.LCM_GLN = "Invalid GLN";
        valid = false;
        logAction("validateForm(): GLN cannot be 0", true);
      }
      else {
        newErrors.other.LCM_GLN = "";
      }
    }

    // Validate LCM_SGLN if provided
    // if (LocMEdit.LCM_SGLN) {
    //   // Check if it contains only digits and dots
    //   if (!/^[\d.]+$/.test(LocMEdit.LCM_SGLN)) {
    //     newErrors.other.LCM_SGLN = "Only numeric digits and Dot (.) are allowed";
    //     valid = false;
    //     logAction("validateForm(): Only numeric digits and Dot (.) are allowed", true);
    //   }
    //   // Check if it's all zeros (with optional dots)
    //   else if (/^[0.]+$/.test(LocMEdit.LCM_SGLN) && LocMEdit.LCM_SGLN.replace(/\./g, '').length > 0) {
    //     // Check if all characters are either 0 or .
    //     const hasOnlyZerosAndDots = /^[0.]+$/.test(LocMEdit.LCM_SGLN);
    //     const hasAtLeastOneDigit = /[0-9]/.test(LocMEdit.LCM_SGLN);

    //     if (hasOnlyZerosAndDots && hasAtLeastOneDigit) {
    //       // Remove dots and check if what remains is all zeros
    //       const digitsOnly = LocMEdit.LCM_SGLN.replace(/\./g, '');
    //       if (/^0+$/.test(digitsOnly) || digitsOnly === "0") {
    //         newErrors.other.LCM_SGLN = "Invalid SGLN";
    //         valid = false;
    //         logAction("validateForm(): SGLN cannot be all zeros", true);
    //       } else {
    //         newErrors.other.LCM_SGLN = "";
    //       }
    //     } else {
    //       newErrors.other.LCM_SGLN = "";
    //     }
    //   }
    //   // Check if it's only "0" or "0." or ".0" etc
    //   else if (LocMEdit.LCM_SGLN === "0" || LocMEdit.LCM_SGLN === "0." || LocMEdit.LCM_SGLN === ".0") {
    //     newErrors.other.LCM_SGLN = "Invalid SGLN";
    //     valid = false;
    //     logAction("validateForm(): SGLN cannot be 0 or 0.", true);
    //   }
    //   else {
    //     newErrors.other.LCM_SGLN = "";
    //   }
    // }

    // Validate LCM_SGLN if provided
if (LocMEdit.LCM_SGLN) {

  // 1️⃣ Allow only digits and dot
  if (!/^[\d.]+$/.test(LocMEdit.LCM_SGLN)) {
    newErrors.other.LCM_SGLN = "Only numeric digits and Dot (.) are allowed";
    valid = false;
    logAction("validateForm(): Only numeric digits and Dot (.) are allowed", true);
  }

  // 2️⃣ First and last character must be digit
  else if (
    !/^\d$/.test(LocMEdit.LCM_SGLN[0]) ||
    !/^\d$/.test(LocMEdit.LCM_SGLN.slice(-1))
  ) {
    newErrors.other.LCM_SGLN = "First and last character must be digit";
    valid = false;
    logAction("validateForm(): First and last character must be digit", true);
  }

  // 3️⃣ Consecutive dots not allowed
  else if (/(\.)\1/.test(LocMEdit.LCM_SGLN)) {
    newErrors.other.LCM_SGLN =
      "Consecutive special characters are not allowed";
    valid = false;
    logAction(
      "validateForm(): Consecutive special characters are not allowed",
      true
    );
  }

  // 4️⃣ Check if it's all zeros (ignoring dots)
  else if (/^[0.]+$/.test(LocMEdit.LCM_SGLN)) {
    const digitsOnly = LocMEdit.LCM_SGLN.replace(/\./g, '');
    if (/^0+$/.test(digitsOnly)) {
      newErrors.other.LCM_SGLN = "Invalid SGLN";
      valid = false;
      logAction("validateForm(): SGLN cannot be all zeros", true);
    } else {
      newErrors.other.LCM_SGLN = "";
    }
  }

  else {
    newErrors.other.LCM_SGLN = "";
  }
}
    // Validate LCM_Latitude
    if (!LocMEdit.LCM_Latitude) {
      newErrors.required.LCM_Latitude = "*";
      valid = false;
    } else if (!/^[+-]?\d+(\.\d+)?$/.test(LocMEdit.LCM_Latitude)
    ) {
      newErrors.other.LCM_Latitude = "Please use only numeric values, + and - are allowed";
      valid = false;
      logAction("validateForm():Please use only numeric values, + and - are allowed", true);
    } else if (LocMEdit.LCM_Latitude.length > 15) {
      newErrors.other.LCM_Latitude = "Maximum length is 15 characters.";
      valid = false;
      logAction("validateForm():Maximum length is 15 characters.", true);
    } else {
      newErrors.required.LCM_Latitude = "";
      newErrors.other.LCM_Latitude = "";
    }
    // Validate LCM_Longitude
    if (!LocMEdit.LCM_Longitude) {
      newErrors.required.LCM_Longitude = "*";
      valid = false;
    } else if (!/^[+-]?\d+(\.\d+)?$/.test(LocMEdit.LCM_Longitude)
    ) {
      newErrors.other.LCM_Longitude = "Please use only numeric values, + and - are allowed";
      valid = false;
      logAction("validateForm():Please use only numeric values, + and - are allowed", true);
    } else if (LocMEdit.LCM_Longitude.length > 15) {
      newErrors.other.LCM_Longitude = "Maximum length is 15 characters.";
      valid = false;
      logAction("validateForm():Maximum length is 15 characters.", true);
    } else {
      newErrors.required.LCM_Longitude = "";
      newErrors.other.LCM_Longitude = "";
    }

    // Validate LCM_CompanyEmailID
    // if (
    //   LocMEdit.LCM_CompanyEmailID &&
    //   !/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(
    //     LocMEdit.LCM_CompanyEmailID
    //   )
    // ) {
    //   newErrors.other.LCM_CompanyEmailID = "Invalid email address";
    //   valid = false;
    //   logAction("validateForm():Invalid email address", true);
    // } else {
    //   newErrors.required.LCM_CompanyEmailID = "";
    //   newErrors.other.LCM_CompanyEmailID = "";
    // }
    // Validate LCM_CompanyEmailID
    // if (LocMEdit.LCM_CompanyEmailID) {
    //   // Updated regex to prevent dots in wrong positions
    //   if (!/^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9]+([.-][a-z0-9]+)*\.[a-z]{2,}$/.test(LocMEdit.LCM_CompanyEmailID.toLowerCase())) {
    //     newErrors.other.LCM_CompanyEmailID = "Invalid email format";
    //     valid = false;
    //     logAction("validateForm(): Invalid company email format", true);
    //   } else {
    //     newErrors.required.LCM_CompanyEmailID = "";
    //     newErrors.other.LCM_CompanyEmailID = "";
    //   }
    // } else {
    //   newErrors.required.LCM_CompanyEmailID = "";
    //   newErrors.other.LCM_CompanyEmailID = "";
    // }

    // // Validate LCM_CompanyEmailID
    // if (LocMEdit.LCM_CompanyEmailID) {

    //   const email = LocMEdit.LCM_CompanyEmailID.trim().toLowerCase();

    //   const emailRegex = /^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}(\.[a-z]{2,})?$/;

    //   if (!emailRegex.test(email)) {
    //     newErrors.other.LCM_CompanyEmailID = "Invalid email format";
    //     valid = false;
    //     logAction("validateForm(): Invalid company email format", true);
    //   } else {
    //     newErrors.required.LCM_CompanyEmailID = "";
    //     newErrors.other.LCM_CompanyEmailID = "";
    //   }

    // } else {
    //   newErrors.required.LCM_CompanyEmailID = "";
    //   newErrors.other.LCM_CompanyEmailID = "";
    // }
    if (LocMEdit.LCM_CompanyEmailID) {

      const email = LocMEdit.LCM_CompanyEmailID.trim().toLowerCase();
      const emailRegex = /^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}(\.[a-z]{2,})?$/;

      if (email.length > 45) {
        newErrors.other.LCM_CompanyEmailID = "Email must not exceed 45 characters";
        valid = false;
      } else if (!emailRegex.test(email)) {
        newErrors.other.LCM_CompanyEmailID = "Invalid email format";
        valid = false;
      } else {
        newErrors.other.LCM_CompanyEmailID = "";
      }

    }


    // Validate LCM_URL
    if (
      LocMEdit.LCM_URL &&
      !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(LocMEdit.LCM_URL)
    ) {
      newErrors.other.LCM_URL = "Invalid URL";
      valid = false;
      logAction("validateForm():Invalid URL", true);
    } else {
      newErrors.required.LCM_URL = "";
      newErrors.other.LCM_URL = "";
    }

    // Validate LCM_Status
    if (!LocMEdit.LCM_Status) {
      newErrors.required.LCM_Status = "*";
      valid = false;
    } else {
      newErrors.required.LCM_Status = "";
      newErrors.other.LCM_Status = "";
    }
    // Validate LCM_LocationStreet1
    if (!LocMEdit.LCM_LocationStreet1) {
      newErrors.required.LCM_LocationStreet1 = "*";
      valid = false;
    } else {
      newErrors.required.LCM_LocationStreet1 = "";
      newErrors.other.LCM_LocationStreet1 = "";
    }

    logAction("validateForm():Ended");
    setErrors(newErrors);
    return valid;
  };

  const handleInput = (e) => {
    let { name, value } = e.target;
    // ✅ Automatically convert email fields to lowercase
    if (name === "LCM_EmailID" || name === "LCM_CompanyEmailID") {
      value = value.toLowerCase();
    }
    setLOCEdit((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    logAction("handleInput():Started");

    let valid = true;
    const newErrors = {
      required: { ...errors.required },
      other: { ...errors.other },
    };

    // Validate LCM_LocationName
    if (name === "LCM_LocationName") {
      if (!value) {
        // newErrors.required.LCM_LocationName = "*";
        newErrors.other.LCM_LocationName = "";
        valid = false;
      } else if (
        !/^[a-zA-Z0-9]$/.test(value[0]) ||
        !/^[a-zA-Z0-9]$/.test(value[value.length - 1])
      ) {
        newErrors.other.LCM_LocationName =
          "First and last character must be alphanumeric";
        valid = false;
        logAction(
          "handleInput():First and last character must be alphanumeric",
          true
        );
      } else if (!/^[a-zA-Z0-9_.,/ -\s]+$/.test(value)) {
        newErrors.other.LCM_LocationName =
          "Please use only allowed special characters like . , / , - and _";
        valid = false;
        logAction(
          "handleInput():Please use only allowed special characters like . , / , - and _",
          true
        );
      } else if (/([_.,/ -\s])\1/.test(value)) {
        newErrors.other.LCM_LocationName =
          "Consecutive special characters are not allowed";
        valid = false;
        logAction(
          "handleInput():Consecutive special characters are not allowed",
          true
        );
      } else if (value.length > 45) {
        newErrors.other.LCM_LocationName = "Maximum length is 45 characters.";
        valid = false;
      } else {
        newErrors.required.LCM_LocationName = "";
        newErrors.other.LCM_LocationName = "";
      }
    }

    // Validate LCM_LocationCode
    if (name === "LCM_LocationCode") {
      if (!value) {
        // newErrors.required.LCM_LocationCode = "*";
        newErrors.other.LCM_LocationCode = "";
        valid = false;
      } else if (
        !/^[a-zA-Z0-9\s]$/.test(value[0]) ||
        !/^[a-zA-Z0-9\s]$/.test(value[value.length - 1])
      ) {
        newErrors.other.LCM_LocationCode =
          "First and last character must be alphanumeric";
        valid = false;
        logAction(
          "handleInput():First and last character must be alphanumeric",
          true
        );
      } else if (!/^[a-zA-Z0-9_ -\s]+$/.test(value)) {
        newErrors.other.LCM_LocationCode =
          "Please use only special characters like, - and _";
        valid = false;
        logAction(
          "handleInput():Please use only special characters like, - and _",
          true
        );
      } else if (/[_ -]{2,}/.test(value)) {
        newErrors.other.LCM_LocationCode =
          "Consecutive special characters are not allowed";
        valid = false;
        logAction(
          "handleInput():Consecutive special characters are not allowed",
          true
        );
      } else if (value.length > 45) {
        newErrors.other.LCM_LocationCode = "Maximum length is 45 characters.";
        valid = false;
      } else {
        newErrors.required.LCM_LocationCode = "";
        newErrors.other.LCM_LocationCode = "";
      }
    }

    // Add SCP validation in handleInput
    if (name === "LCM_SCPID" && parseInt(UM_UserType) === 1) {
      if (!value) {
        // newErrors.required.LCM_SCPID = "*";
        valid = false;
      } else {
        newErrors.required.LCM_SCPID = "";
      }
    }

    // Validate LCM_PostalCode
    if (name === "LCM_PostalCode") {
      if (!value) {
        // newErrors.required.LCM_PostalCode = "*";
        newErrors.other.LCM_PostalCode = "";
        valid = false;
      } else if (
        !/^[a-zA-Z0-9]$/.test(value[0]) ||
        !/^[a-zA-Z0-9]$/.test(value[value.length - 1])
      ) {
        newErrors.other.LCM_PostalCode =
          "First and last character must be alphanumeric";
        valid = false;
        logAction(
          "handleInput(): First and last character must be alphanumeric",
          true
        );
      } else if (!/^[a-zA-Z0-9-\s]+$/.test(value)) {
        newErrors.other.LCM_PostalCode =
          "Please use only alphanumeric characters, spaces and -";
        valid = false;
        logAction(
          "handleInput(): Please use only alphanumeric characters, spaces and -",
          true
        );
      } else if (/[- ]{2,}/.test(value)) {
        newErrors.other.LCM_PostalCode = "Consecutive special characters are not allowed";
        valid = false;
        logAction("handleInput(): Consecutive special characters are not allowed", true);
      } else {
        newErrors.required.LCM_PostalCode = "";
        newErrors.other.LCM_PostalCode = "";
      }
    }

    // Validate LCM_City
    if (name === "LCM_City") {
      if (!value) {
        // newErrors.required.LCM_City = "*";
        newErrors.other.LCM_City = "";
        valid = false;
      } else if (!/^[a-zA-Z\s]*$/.test(value)) {
        newErrors.other.LCM_City = "Only alphabets are allowed";
        valid = false;
        logAction("handleInput(): Only alphabets are allowed", true);
      } else {
        newErrors.required.LCM_City = "";
        newErrors.other.LCM_City = "";
      }
    }

    // Validate LCM_State
    if (name === "LCM_State") {
      if (!value) {
        // newErrors.required.LCM_State = "*";
        newErrors.other.LCM_State = "";
        valid = false;
      } else if (!/^[a-zA-Z\s]*$/.test(value)) {
        newErrors.other.LCM_State = "Only alphabets are allowed";
        valid = false;
        logAction("handleInput(): Only alphabets are allowed", true);
      } else {
        newErrors.required.LCM_State = "";
        newErrors.other.LCM_State = "";
      }
    }

    // Validate LCM_Country
    if (name === "LCM_Country") {
      if (!value) {
        // newErrors.required.LCM_Country = "*";
        newErrors.other.LCM_Country = "";
        valid = false;
      } else if (!/^[a-zA-Z\s]*$/.test(value)) {
        newErrors.other.LCM_Country = "Only alphabets are allowed";
        valid = false;
        logAction("handleInput(): Only alphabets are allowed", true);
      } else {
        newErrors.required.LCM_Country = "";
        newErrors.other.LCM_Country = "";
      }
    }

    // Validate LCM_District
    if (name === "LCM_District") {
      if (!/^[a-zA-Z\s]*$/.test(value)) {
        newErrors.other.LCM_District = "Only alphabets are allowed";
        valid = false;
        logAction("handleInput(): Only alphabets are allowed", true);
      } else {
        newErrors.required.LCM_District = "";
        newErrors.other.LCM_District = "";
      }
    }

    // Validate LCM_EmailID
    //  // Validate LCM_EmailID
    // if (name === "LCM_EmailID") {
    //   if (value) {
    //     // Updated regex to prevent dots in wrong positions
    //     if (!/^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9]+([.-][a-z0-9]+)*\.[a-z]{2,}$/.test(value.toLowerCase())) {
    //       newErrors.other.LCM_EmailID = "Invalid email format";
    //       valid = false;
    //       logAction("handleInput(): Invalid email format", true);
    //     } else {
    //       newErrors.required.LCM_EmailID = "";
    //       newErrors.other.LCM_EmailID = "";
    //     }
    //   } else {
    //     newErrors.required.LCM_EmailID = "";
    //     newErrors.other.LCM_EmailID = "";
    //   }
    // }

    // Validate LCM_EmailID
    if (name === "LCM_EmailID") {

      const email = value.trim().toLowerCase();
      const emailRegex = /^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}(\.[a-z]{2,})?$/;

      if (email) {

        // ✅ Length check
        if (email.length > 45) {
          newErrors.other.LCM_EmailID = "Email must not exceed 45 characters";
          valid = false;
          logAction("handleInput(): Email length exceeded", true);
        }

        // ✅ Format check
        else if (!emailRegex.test(email)) {
          newErrors.other.LCM_EmailID = "Invalid email format";
          valid = false;
          logAction("handleInput(): Invalid email format", true);
        }

        else {
          newErrors.required.LCM_EmailID = "";
          newErrors.other.LCM_EmailID = "";
        }

      } else {
        newErrors.required.LCM_EmailID = "";
        newErrors.other.LCM_EmailID = "";
      }
    }

    // Don't handle phone validation in handleInput since it's handled separately
    if (name === "LCM_ContactNumber") return;

    // // // Validate LCM_GLN
    // // if (name === "LCM_GLN") {
    // //   if (value.trim() !== "" && !/^\d+$/.test(value)) {
    // //     newErrors.other.LCM_GLN = "Only numeric digits are allowed";
    // //     valid = false;
    // //     logAction("handleInput(): Only numeric digits are allowed", true);
    // //   } else {
    // //     newErrors.other.LCM_GLN = "";
    // //   }
    // // }

    // // // Validate LCM_SGLN
    // // if (name === "LCM_SGLN") {
    // //   if (value && !/^[\d.]+$/.test(value)) {
    // //     newErrors.other.LCM_SGLN = "Only numeric digits and Dot (.) are allowed";
    // //     valid = false;
    // //     logAction("handleInput(): Only numeric digits and Dot (.) are allowed", true);
    // //   } else {
    // //     newErrors.required.LCM_SGLN = "";
    // //     newErrors.other.LCM_SGLN = "";
    // //   }
    // // }
    // // Validate LCM_GLN
    // if (name === "LCM_GLN") {
    //   if (value && !/^\d*$/.test(value)) {
    //     newErrors.other.LCM_GLN = "Only numeric digits are allowed";
    //     valid = false;
    //     logAction("handleInput(): Only numeric digits are allowed", true);
    //   } else {
    //     newErrors.required.LCM_GLN = "";
    //     newErrors.other.LCM_GLN = "";
    //   }
    // }

    // // Validate LCM_SGLN
    // if (name === "LCM_SGLN") {
    //   if (value && !/^[\d.]*$/.test(value)) {
    //     newErrors.other.LCM_SGLN = "Only numeric digits and Dot (.) are allowed";
    //     valid = false;
    //     logAction("handleInput(): Only numeric digits and Dot (.) are allowed", true);
    //   } else {
    //     newErrors.required.LCM_SGLN = "";
    //     newErrors.other.LCM_SGLN = "";
    //   }
    // }

    // Validate LCM_GLN
    if (name === "LCM_GLN") {
      if (value) {
        if (!/^\d*$/.test(value)) {
          newErrors.other.LCM_GLN = "Only numeric digits are allowed";
          valid = false;
          logAction("handleInput(): Only numeric digits are allowed", true);
        }
        else if (/^0+$/.test(value)) {
          newErrors.other.LCM_GLN = "Invalid GLN";
          valid = false;
          logAction("handleInput(): GLN cannot be all zeros", true);
        }
        else if (value === "0") {
          newErrors.other.LCM_GLN = "Invalid GLN";
          valid = false;
          logAction("handleInput(): GLN cannot be 0", true);
        }
        else {
          newErrors.required.LCM_GLN = "";
          newErrors.other.LCM_GLN = "";
        }
      } else {
        newErrors.required.LCM_GLN = "";
        newErrors.other.LCM_SGLN = "";
      }
    }

    // Validate LCM_SGLN
    // if (name === "LCM_SGLN") {
    //   if (value) {
    //     if (!/^[\d.]*$/.test(value)) {
    //       newErrors.other.LCM_SGLN = "Only numeric digits and Dot (.) are allowed";
    //       valid = false;
    //       logAction("handleInput(): Only numeric digits and Dot (.) are allowed", true);
    //     }
    //     else if (/^[0.]+$/.test(value) && value.replace(/\./g, '').length > 0) {
    //       // Check if all characters are either 0 or .
    //       const hasOnlyZerosAndDots = /^[0.]+$/.test(value);
    //       const hasAtLeastOneDigit = /[0-9]/.test(value);

    //       if (hasOnlyZerosAndDots && hasAtLeastOneDigit) {
    //         // Remove dots and check if what remains is all zeros
    //         const digitsOnly = value.replace(/\./g, '');
    //         if (/^0+$/.test(digitsOnly) || digitsOnly === "0") {
    //           newErrors.other.LCM_SGLN = "Invalid SGLN";
    //           valid = false;
    //           logAction("handleInput(): SGLN cannot be all zeros", true);
    //         } else {
    //           newErrors.required.LCM_SGLN = "";
    //           newErrors.other.LCM_SGLN = "";
    //         }
    //       } else {
    //         newErrors.required.LCM_SGLN = "";
    //         newErrors.other.LCM_SGLN = "";
    //       }
    //     }
    //     else if (value === "0" || value === "0." || value === ".0") {
    //       newErrors.other.LCM_SGLN = "Invalid SGLN";
    //       valid = false;
    //       logAction("handleInput(): SGLN cannot be 0 or 0.", true);
    //     }
    //     else {
    //       newErrors.required.LCM_SGLN = "";
    //       newErrors.other.LCM_SGLN = "";
    //     }
    //   } else {
    //     newErrors.required.LCM_SGLN = "";
    //     newErrors.other.LCM_SGLN = "";
    //   }
    // }
    // Validate LCM_SGLN
if (name === "LCM_SGLN") {
  if (value) {

    // 1️⃣ Allow only digits and dot
    if (!/^[\d.]*$/.test(value)) {
      newErrors.other.LCM_SGLN =
        "Only numeric digits and Dot (.) are allowed";
      valid = false;
      logAction(
        "handleInput(): Only numeric digits and Dot (.) are allowed",
        true
      );
    }

    // 2️⃣ First and last character must be digit
    else if (
      !/^\d$/.test(value[0]) ||
      !/^\d$/.test(value[value.length - 1])
    ) {
      newErrors.other.LCM_SGLN =
        "First and last character must be digit";
      valid = false;
      logAction(
        "handleInput(): First and last character must be digit",
        true
      );
    }

    // 3️⃣ Consecutive dots not allowed
    else if (/(\.)\1/.test(value)) {
      newErrors.other.LCM_SGLN =
        "Consecutive special characters are not allowed";
      valid = false;
      logAction(
        "handleInput(): Consecutive special characters are not allowed",
        true
      );
    }

    // 4️⃣ Check if all zeros (ignoring dots)
    else if (/^[0.]+$/.test(value)) {
      const digitsOnly = value.replace(/\./g, '');
      if (/^0+$/.test(digitsOnly)) {
        newErrors.other.LCM_SGLN = "Invalid SGLN";
        valid = false;
        logAction(
          "handleInput(): SGLN cannot be all zeros",
          true
        );
      } else {
        newErrors.required.LCM_SGLN = "";
        newErrors.other.LCM_SGLN = "";
      }
    }

    else {
      newErrors.required.LCM_SGLN = "";
      newErrors.other.LCM_SGLN = "";
    }

  } else {
    newErrors.required.LCM_SGLN = "";
    newErrors.other.LCM_SGLN = "";
  }
}
    // Validate LCM_Latitude
    if (name === "LCM_Latitude") {
      if (!value) {
        // newErrors.required.LCM_Latitude = "*";
        newErrors.other.LCM_Latitude = "";
        valid = false;
      } else if (!/^[+-]?\d+(\.\d+)?$/.test(value)) {
        newErrors.other.LCM_Latitude =
          "Please use only numeric values, + and - are allowed";
        valid = false;
        logAction(
          "handleInput(): Please use only numeric values, + and - are allowed",
          true
        );
      }
      // Check if the length exceeds the maximum allowed length
      else if (value.length > 15) {
        newErrors.other.LCM_Latitude = "Maximum length is 15 characters.";
        valid = false;
        logAction("handleInput(): Maximum length is 15 characters.", true);
      } else {
        newErrors.required.LCM_Latitude = "";
        newErrors.other.LCM_Latitude = "";
      }
    }

    if (name === "LCM_Longitude") {
      if (!value) {
        // newErrors.required.LCM_Longitude = "*";
        newErrors.other.LCM_Longitude = "";
        valid = false;
      } else if (!/^[+-]?\d+(\.\d+)?$/.test(value)) {
        newErrors.other.LCM_Longitude =
          "Please use only numeric values, + and - are allowed";
        valid = false;
        logAction(
          "handleInput(): Please use only numeric values, + and - are allowed",
          true
        );
      } else if (value.length > 15) {
        newErrors.other.LCM_Longitude = "Maximum length is 15 characters.";
        valid = false;
        logAction("handleInput(): Maximum length is 15 characters.", true);
      } else {
        newErrors.required.LCM_Longitude = "";
        newErrors.other.LCM_Longitude = "";
      }
    }

    // Validate LCM_CompanyEmailID
    if (name === "LCM_CompanyEmailID") {

      const email = value.trim().toLowerCase();
      const emailRegex = /^[a-z0-9]+([._%+-][a-z0-9]+)*@[a-z0-9-]+\.[a-z]{2,}(\.[a-z]{2,})?$/;

      if (email) {

        // ✅ Length validation (max 45)
        if (email.length > 45) {
          newErrors.other.LCM_CompanyEmailID = "Email must not exceed 45 characters";
          valid = false;
          logAction("handleInput(): Company email length exceeded", true);
        }

        // ✅ Format validation
        else if (!emailRegex.test(email)) {
          newErrors.other.LCM_CompanyEmailID = "Invalid email format";
          valid = false;
          logAction("handleInput(): Invalid company email format", true);
        }

        else {
          newErrors.required.LCM_CompanyEmailID = "";
          newErrors.other.LCM_CompanyEmailID = "";
        }

      } else {
        newErrors.required.LCM_CompanyEmailID = "";
        newErrors.other.LCM_CompanyEmailID = "";
      }
    }


    // Validate LCM_URL
    if (name === "LCM_URL") {
      if (value && !/^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/.test(value)) {
        newErrors.other.LCM_URL = "Invalid URL";
        valid = false;
        logAction("handleInput(): Invalid URL", true);
      } else {
        newErrors.required.LCM_URL = "";
        newErrors.other.LCM_URL = "";
      }
    }

    // Validate LCM_Status
    if (name === "LCM_Status") {
      if (!value) {
        // newErrors.required.LCM_Status = "*";
        newErrors.other.LCM_Status = "";
        valid = false;
      } else {
        newErrors.required.LCM_Status = "";
        newErrors.other.LCM_Status = "";
      }
    }
    if (name === "LCM_LocationStreet1") {
      if (!value) {
        // newErrors.required.LCM_LocationStreet1 = "*";
        newErrors.other.LCM_LocationStreet1 = "";
        valid = false;
      } else {
        newErrors.required.LCM_LocationStreet1 = "";
        newErrors.other.LCM_LocationStreet1 = "";
      }
    }
    setErrors(newErrors);
    if (!valid) {
      return;
    }
    logAction("handleInput():Ended");
  };

  const handleCancel = (e) => {
    e.preventDefault();
    // Store the current SCP value before resetting
    const currentSCPValue = LocMEdit.LCM_SCPID;
    const currentSCPOption = selectedScpOption;
    console.log("currentSCPValue:", currentSCPValue, currentSCPOption);
    setLOCEdit({
      LCM_SCPID: currentSCPOption, // Preserve the SCP ID
      LCM_LocationName: "",
      LCM_LocationCode: "",
      LCM_Type: "",
      LCM_LocationStreet1: "",
      LCM_GLN: "",
      LCM_SGLN: "",
      LCM_Status: 1,
      LCM_LocationStreet2: "",
      LCM_PostalCode: "",
      LCM_City: "",
      LCM_State: "",
      LCM_Country: "",
      LCM_ShippingCountryCode: "",
      LCM_District: "",
      LCM_EmailID: "",
      LCM_ContactNumber: "",
      LCM_ContactCountryCode: "+91", // Reset country code
      LCM_Latitude: "",
      LCM_Longitude: "",
      LCM_CompanyEmailID: "",
      LCM_URL: "",
      LCM_LabelAddress1: "",
      LCM_LabelAddress2: "",
      LCM_LabelAddress3: "",
      LCM_LabelAddress4: "",
      LCM_LabelAddress5: "",
    });
    // Reset dropdowns
    if (parseInt(UM_UserType) === 1) {
      setSelectedScpOption(selectedScpOption);
    }
    setSelectedLocationType(null);
    setSelectedShippingCountryCode(null);
    setSelectedStatus(selectedStatus && { value: 1, label: "Active" });

    // Reset PhoneInput by updating the key
    setPhoneResetKey(prev => prev + 1);

    setErrors({
      required: {
        LCM_LocationName: "",
        LCM_LocationCode: "",
        LCM_Type: "",
        LCM_LocationStreet1: "",
        LCM_GLN: "",
        LCM_SGLN: "",
        LCM_Status: "",
        LCM_LocationStreet2: "",
        LCM_PostalCode: "",
        LCM_City: "",
        LCM_State: "",
        LCM_Country: "",
        LCM_ShippingCountryCode: "",
        LCM_District: "",
        LCM_EmailID: "",
        LCM_ContactNumber: "",
        LCM_Latitude: "",
        LCM_Longitude: "",
        LCM_CompanyEmailID: "",
        LCM_URL: "",
        LCM_LabelAddress1: "",
        LCM_LabelAddress2: "",
        LCM_LabelAddress3: "",
        LCM_LabelAddress4: "",
        LCM_LabelAddress5: "",
      },
      other: {
        LCM_LocationName: "",
        LCM_LocationCode: "",
        LCM_Type: "",
        LCM_LocationStreet1: "",
        LCM_GLN: "",
        LCM_SGLN: "",
        LCM_Status: "",
        LCM_LocationStreet2: "",
        LCM_PostalCode: "",
        LCM_City: "",
        LCM_State: "",
        LCM_Country: "",
        LCM_ShippingCountryCode: "",
        LCM_District: "",
        LCM_EmailID: "",
        LCM_ContactNumber: "",
        LCM_Latitude: "",
        LCM_Longitude: "",
        LCM_CompanyEmailID: "",
        LCM_URL: "",
        LCM_LabelAddress1: "",
        LCM_LabelAddress2: "",
        LCM_LabelAddress3: "",
        LCM_LabelAddress4: "",
        LCM_LabelAddress5: "",
      },
    });
    setMessage("");
  };

  const audittransection = async (data) => {
    const LocMEdit = {
      AUTRN_ID: data.AUTRN_ID,
      AUTRN_OldValue: data.AUTR_NewValue ?? null,
      AUTRN_NewValue: data.AUTRN_NewValue,
      AUTRN_ParamererName: data.AUTRN_ParamererName,
    };
    console.log(LocMEdit);
    try {
      const response = await axios.post(
        `${config.API_URL}/api/audittransaction`,
        LocMEdit
      );
    } catch (error) {
      if (error.response) {
        console.error("Server responded with an error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
    }
  };

  // const handleUpdate = async (e) => {
  //   e.preventDefault(); // Prevent default form submission behavior
  //   if (!validateForm()) {
  //     return;
  //   }

  //   const editInputvalue = {
  //     LCM_LocationName: LocMEdit.LCM_LocationName,
  //     LCM_LocationCode: LocMEdit.LCM_LocationCode,
  //     LCM_Type: LocMEdit.LCM_Type,
  //     LCM_CompanyID: LocMEdit.LCM_CompanyID,
  //     LCM_SCPID: parseInt(UM_UserType) === 1 ? LocMEdit.LCM_SCPID : selectedScpId,
  //     LCM_LocationStreet1: LocMEdit.LCM_LocationStreet1,
  //     LCM_LocationStreet2: LocMEdit.LCM_LocationStreet2,
  //     LCM_PostalCode: LocMEdit.LCM_PostalCode,
  //     LCM_City: LocMEdit.LCM_City,
  //     LCM_State: LocMEdit.LCM_State,
  //     LCM_Country: LocMEdit.LCM_Country,
  //     LCM_ShippingCountryCode: LocMEdit.LCM_ShippingCountryCode,
  //     LCM_District: LocMEdit.LCM_District,
  //     LCM_EmailID: LocMEdit.LCM_EmailID,
  //     LCM_ContactNumber: LocMEdit.LCM_ContactNumber,
  //     LCM_GLN: LocMEdit.LCM_GLN,
  //     LCM_SGLN: LocMEdit.LCM_SGLN,
  //     LCM_Latitude: LocMEdit.LCM_Latitude,
  //     LCM_Longitude: LocMEdit.LCM_Longitude,
  //     LCM_CompanyEmailID: LocMEdit.LCM_CompanyEmailID,
  //     LCM_URL: LocMEdit.LCM_URL,
  //     LCM_LabelAddress1: LocMEdit.LCM_LabelAddress1,
  //     LCM_LabelAddress2: LocMEdit.LCM_LabelAddress2,
  //     LCM_LabelAddress3: LocMEdit.LCM_LabelAddress3,
  //     LCM_LabelAddress4: LocMEdit.LCM_LabelAddress4,
  //     LCM_LabelAddress5: LocMEdit.LCM_LabelAddress5,
  //     LCM_Status: LocMEdit.LCM_Status,
  //     LCM_CompanyGrpId: LocMEdit.LCM_CompanyGrpId,
  //   };
  //   try {
  //     const res = await fetch(
  //       `${config.API_URL}/LocationMasterUpdateValues/${LCM_ID}`,
  //       {
  //         method: "PUT",
  //         headers: { "content-type": "application/json" },
  //         body: JSON.stringify(editInputvalue),
  //       }
  //     );
  //     const resjson = await res.json();
  //     if (res.status === 200) {
  //       setMessage(resjson.success);
  //     } else {
  //       showToast('error',"Error in saving data. Please try again");
  //     }
  //   } catch (error) {
  //     console.log("Error updating user data", error);
  //     const newdata = {
  //       LCM_LocationName: LocMEdit.LCM_LocationName,
  //       LCM_LocationCode: LocMEdit.LCM_LocationCode,
  //       LCM_Type: LocMEdit.LCM_Type,
  //       LCM_LocationStreet1: LocMEdit.LCM_LocationStreet1,
  //       LCM_LocationStreet2: LocMEdit.LCM_LocationStreet2,
  //       LCM_PostalCode: LocMEdit.LCM_PostalCode,
  //       LCM_City: LocMEdit.LCM_City,
  //       LCM_State: LocMEdit.LCM_State,
  //       LCM_Country: LocMEdit.LCM_Country,
  //       LCM_ShippingCountryCode: LocMEdit.LCM_ShippingCountryCode,
  //       LCM_District: LocMEdit.LCM_District,
  //       LCM_EmailID: LocMEdit.LCM_EmailID,
  //       LCM_ContactNumber: LocMEdit.LCM_ContactNumber,
  //       LCM_GLN: LocMEdit.LCM_GLN,
  //       LCM_SGLN: LocMEdit.LCM_SGLN,
  //       LCM_Latitude: LocMEdit.LCM_Latitude,
  //       LCM_Longitude: LocMEdit.LCM_Longitude,
  //       LCM_CompanyEmailID: LocMEdit.LCM_CompanyEmailID,
  //       LCM_URL: LocMEdit.LCM_URL,
  //       LCM_LabelAddress1: LocMEdit.LCM_LabelAddress1,
  //       LCM_LabelAddress2: LocMEdit.LCM_LabelAddress2,
  //       LCM_LabelAddress3: LocMEdit.LCM_LabelAddress3,
  //       LCM_LabelAddress4: LocMEdit.LCM_LabelAddress4,
  //       LCM_LabelAddress5: LocMEdit.LCM_LabelAddress5,
  //       LCM_Status: LocMEdit.LCM_Status,
  //     };

  //     console.log("OLD DATA - ", olddata);
  //     console.log("NEW DATA - ", newdata);
  //     const details = {
  //       AUTR_Message: `${olddata.LCM_LocationName} Location  updated`,
  //       AUTR_AuditType: "Update",
  //     };
  //     let id = await audittrailpost(details);
  //     function findChangedKeys(oldObj, newObj) {
  //       for (let key in oldObj) {
  //         if (oldObj.hasOwnProperty(key) && newObj.hasOwnProperty(key)) {
  //           if (oldObj[key] !== newObj[key]) {
  //             const details = {
  //               AUTRN_ParamererName: key,
  //               AUTRN_NewValue: newObj[key],
  //               AUTRN_ID: id,
  //               AUTRN_OldValue: oldObj[key],
  //             };
  //             audittransection(details);
  //           }
  //         }
  //       }
  //     }

  //     findChangedKeys(olddata, newdata);
  //     showToast('success',`Location : ${LocMEdit.LCM_LocationName} updated successfully.`, {
  //       onClose: () => {
  //         navigate(`/dashboard/LocationMaster`);
  //       },
  //     });
  //     setLOCEdit({
  //       LCM_LocationName: "",
  //       LCM_LocationCode: "",
  //       LCM_Type: "",
  //       LCM_CompanyID: UM_CompanyID,
  //       LCM_SCPID: parseInt(UM_UserType) === 1 && selectedScpOption.label ? selectedScpOption.value : selectedScpId,
  //       LCM_LocationStreet1: "",
  //       LCM_LocationStreet2: "",
  //       LCM_PostalCode: "",
  //       LCM_City: "",
  //       LCM_State: "",
  //       LCM_Country: "",
  //       LCM_ShippingCountryCode: "",
  //       LCM_District: "",
  //       LCM_EmailID: "",
  //       LCM_ContactNumber: "",
  //       LCM_ContactCountryCode: "+91", // Reset country code
  //       LCM_GLN: "",
  //       LCM_SGLN: "",
  //       LCM_Latitude: "",
  //       LCM_Longitude: "",
  //       LCM_CompanyEmailID: "",
  //       LCM_URL: "",
  //       LCM_LabelAddress1: "",
  //       LCM_LabelAddress2: "",
  //       LCM_LabelAddress3: "",
  //       LCM_LabelAddress4: "",
  //       LCM_LabelAddress5: "",
  //       LCM_Status: 1,
  //     });
  //     // Reset dropdowns
  //     setSelectedLocationType(null);
  //     setSelectedShippingCountryCode(null);
  //   setSelectedStatus(selectedStatus && { value: 1, label: "Active" });

  //     // Reset PhoneInput by updating the key
  //     setPhoneResetKey(prev => prev + 1);
  //   }
  // };
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const editInputvalue = {
      LCM_LocationName: LocMEdit.LCM_LocationName,
      LCM_LocationCode: LocMEdit.LCM_LocationCode,
      LCM_Type: LocMEdit.LCM_Type,
      LCM_CompanyID: LocMEdit.LCM_CompanyID,
      LCM_SCPID:
        parseInt(UM_UserType) === 1 ? LocMEdit.LCM_SCPID : selectedScpId,
      LCM_LocationStreet1: LocMEdit.LCM_LocationStreet1,
      LCM_LocationStreet2: LocMEdit.LCM_LocationStreet2,
      LCM_PostalCode: LocMEdit.LCM_PostalCode,
      LCM_City: LocMEdit.LCM_City,
      LCM_State: LocMEdit.LCM_State,
      LCM_Country: LocMEdit.LCM_Country,
      LCM_ShippingCountryCode: LocMEdit.LCM_ShippingCountryCode,
      LCM_District: LocMEdit.LCM_District,
      LCM_EmailID: LocMEdit.LCM_EmailID,
      LCM_ContactNumber: LocMEdit.LCM_ContactNumber,
      LCM_GLN: LocMEdit.LCM_GLN,
      LCM_SGLN: LocMEdit.LCM_SGLN,
      LCM_Latitude: LocMEdit.LCM_Latitude,
      LCM_Longitude: LocMEdit.LCM_Longitude,
      LCM_CompanyEmailID: LocMEdit.LCM_CompanyEmailID,
      LCM_URL: LocMEdit.LCM_URL,
      LCM_LabelAddress1: LocMEdit.LCM_LabelAddress1,
      LCM_LabelAddress2: LocMEdit.LCM_LabelAddress2,
      LCM_LabelAddress3: LocMEdit.LCM_LabelAddress3,
      LCM_LabelAddress4: LocMEdit.LCM_LabelAddress4,
      LCM_LabelAddress5: LocMEdit.LCM_LabelAddress5,
      LCM_Status: LocMEdit.LCM_Status,
    };

    try {
      const res = await fetch(
        `${config.API_URL}/LocationMasterUpdateValues/${LCM_ID}`,
        {
          method: "PUT",
          headers: { "content-type": "application/json" },
          body: JSON.stringify(editInputvalue),
        }
      );

      const message = await res.text();
      setLoading(true); // Start loading

      /* =========================
         SUCCESS
      ========================= */
      if (res.status === 200) {
        showToast('success', `Location : ${LocMEdit.LCM_LocationName} updated successfully.`, {
          onClose: () => {
            handleCancel(e);
            navigate(`/dashboard/LocationMaster`)
            setLoading(false);
          }
          // Reset the form

        });
        logAction(message);
        return;
      }

      /* =========================
         DUPLICATE (NAME / CODE / BOTH)
      ========================= */
      if (res.status === 409) {
        showToast('error', message, true);
        logAction(message, true);
        return;
      }

      /* =========================
         OTHER ERRORS
      ========================= */
      showToast('error', message || "Error in updating data. Please try again");
      logAction(message || "Error in updating data", true);

    } catch (error) {
      console.error("Network error:", error);
      showToast('error', "Error in updating data. Please try again");
      logAction("Error in updating data. Please try again", true);
      setLoading(false); // Start loading

    }
  };

  const [isSelectOpen, setIsSelectOpen] = useState(null);
    const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
    if (selectName === "LCM_Status") {
      setTimeout(() => {
        const mainContainer = document.querySelector('.main_container');
        const dropdown = document.querySelector('.routing_select-box .react-select__menu');
        const dropdownHeight = dropdown ? dropdown.offsetHeight : 100; // Fallback height
        const gap = 20; // Desired gap
        if (mainContainer) {
          mainContainer.style.paddingBottom = `${dropdownHeight + gap}px`;
          mainContainer.scrollTo({
            top: mainContainer.scrollHeight,
            behavior: "smooth"
          });
        }
      }, 100);
    }
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
    const mainContainer = document.querySelector('.main_container');
    if (mainContainer) {
      mainContainer.style.paddingBottom = ''; // Reset padding
    }
  };
  // const handleSelectOpen = (selectName) => {
  //   setIsSelectOpen(selectName);
  // };

  // const handleSelectClose = () => {
  //   setIsSelectOpen(null);
  // };

  return (
    <React.Fragment>
      <ToastContainer style={{ marginTop: '73px', fontSize: '14px', width: '40%' }} />

      {loading && (
        <div style={{
          position: 'fixed', // Sit on top of the page content
          left: 0,
          top: 0,
          width: '100%', // Full width
          height: '100%', // Full height

          zIndex: 1000 // Sit on top of the other elements
        }} />
      )}
      <form onSubmit={handleUpdate}>
        <div className="main_container">
          <div className="row">
            <div className="col-md-12">
              <h4 className="formHeading">Location Master</h4>

              <div className="row">
                {/* Add the SCP dropdown field after Location Type field */}
                {parseInt(UM_UserType) === 1 && (
                  <div className="col-md-3">
                    <div className="mb-1">
                      <label className="">
                        SCP Name{" "}
                        <span className="text-danger">
                          {errors.required.LCM_SCPID}
                        </span>
                      </label>
                      <div className="location_select-container">
                        <Select
                          classNamePrefix="select"
                          isDisabled={true}
                          isSearchable={true}
                          name="LCM_SCPID"
                          options={scpOptions}
                          value={selectedScpOption}
                          onChange={handleScpChange}
                          placeholder="--Select--"
                          onMenuOpen={() => handleSelectOpen("LCM_SCPID")}
                          onMenuClose={handleSelectClose}
                          maxMenuHeight={150}
                        />
                        <div className="icon-container_list myList">
                          {isSelectOpen === "LCM_SCPID" ? (
                            <IoCaretUpOutline />
                          ) : (
                            <IoCaretDownOutline />
                          )}
                        </div>
                      </div>
                      <div className="text-danger">
                        {errors.other.LCM_SCPID}
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Location Name{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_LocationName}
                      </span>
                    </label>
                    <input
                      name="LCM_LocationName"
                      className="location_form_input"
                      placeholder=""
                      value={LocMEdit.LCM_LocationName}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_LocationName}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Location Code{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_LocationCode}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LocationCode"
                      className="location_form_input"
                      value={LocMEdit.LCM_LocationCode}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_LocationCode}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Location Type{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_Type}
                      </span>
                    </label>
                    <div className="location_select-container">
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        name="LCM_Type"
                        options={locationTypeOptions}
                        value={selectedLocationType}
                        onChange={handleLocationTypeChange}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen("LCM_Type")}
                        onMenuClose={handleSelectClose}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "LCM_Type" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                    <div className="text-danger ">
                      {errors.other.LCM_Type}
                    </div>
                  </div>
                </div>

                <div className="col-md-3">
                  <div className="mb-1">
                    <label>
                      Street 1 <span className="text-danger ">
                        {errors.required.LCM_LocationStreet1}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LocationStreet1"
                      className="location_form_input"
                      value={LocMEdit.LCM_LocationStreet1}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Street 2 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LocationStreet2"
                      className="location_form_input"
                      value={LocMEdit.LCM_LocationStreet2}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Postal Code{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_PostalCode}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_PostalCode"
                      className="location_form_input"
                      value={LocMEdit.LCM_PostalCode}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_PostalCode}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      City
                      <span className="text-danger ">
                        {errors.required.LCM_City}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_City"
                      className="location_form_input"
                      value={LocMEdit.LCM_City}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_City}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      State{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_State}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_State"
                      className="location_form_input"
                      value={LocMEdit.LCM_State}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_State}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Country{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_Country}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_Country"
                      className="location_form_input"
                      value={LocMEdit.LCM_Country}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_Country}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Shipping Country Code
                      <span className="text-danger ">
                        {errors.required.LCM_ShippingCountryCode}
                      </span>
                    </label>
                    <div className="location_select-container">
                      <Select
                        classNamePrefix="select"
                        isSearchable={true}
                        name="LCM_ShippingCountryCode"
                        options={shippingCountryCodeOptions}
                        value={selectedShippingCountryCode}
                        onChange={handleShippingCountryCodeChange}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen("LCM_ShippingCountryCode")}
                        onMenuClose={handleSelectClose}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "LCM_ShippingCountryCode" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                    <div className="text-danger ">
                      {errors.other.LCM_ShippingCountryCode}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">District </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_District"
                      className="location_form_input"
                      value={LocMEdit.LCM_District}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_District}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Email{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_EmailID}
                      </span>
                    </label>
                    <input
                      type="email"
                      label="Date"
                      locale="en-US"
                      name="LCM_EmailID"
                      className="location_form_input"
                      value={LocMEdit.LCM_EmailID}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_EmailID}
                    </div>
                  </div>
                </div>
                {/* Phone Input Field - Same as UMEdit */}
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Phone Number </label>
                    <PhoneInput
                      key={phoneResetKey}
                      country="in"
                      value={LocMEdit.LCM_ContactNumber || ''}
                      onChange={handlePhoneChange}
                      inputProps={{
                        name: 'LCM_ContactNumber',
                        id: 'LCM_ContactNumber',
                        autoComplete: 'new-password',
                        onKeyDown: (e) => {
                          if (e.target.value === '' && e.key === '0') {
                            e.preventDefault();
                          }
                        },
                        onBlur: () => validatePhone(LocMEdit.LCM_ContactNumber)
                      }}
                      preferredCountries={['in', 'us', 'gb']}
                      countryCodeEditable={false}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_ContactNumber}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">GLN <span className="text-danger ">{errors.required.LCM_GLN}</span> </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_GLN"
                      className="location_form_input"
                      value={LocMEdit.LCM_GLN}
                      maxLength={13}
                      onChange={handleInput}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_GLN}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">SGLN <span className="text-danger ">{errors.required.LCM_SGLN}</span> </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_SGLN"
                      className="location_form_input"
                      value={LocMEdit.LCM_SGLN}
                      minLength={14}
                      maxLength={16}
                      onChange={handleInput}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_SGLN}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Latitude <span className="text-danger ">{errors.required.LCM_Latitude}</span> </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_Latitude"
                      className="location_form_input"
                      value={LocMEdit.LCM_Latitude}
                      onChange={handleInput}
                      maxLength={11}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_Latitude}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Longitude <span className="text-danger ">{errors.required.LCM_Longitude}</span> </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_Longitude"
                      className="location_form_input"
                      value={LocMEdit.LCM_Longitude}
                      onChange={handleInput}
                      maxLength={11}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_Longitude}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Company Email{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_CompanyEmailID}
                      </span>
                    </label>
                    <input
                      label="Date"
                      locale="en-US"
                      type="email"
                      name="LCM_CompanyEmailID"
                      className="location_form_input"
                      value={LocMEdit.LCM_CompanyEmailID}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_CompanyEmailID}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Company URL </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_URL"
                      className="location_form_input"
                      value={LocMEdit.LCM_URL}
                      onChange={handleInput}
                      maxLength={45}
                    />
                    <div className="text-danger ">
                      {errors.other.LCM_URL}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Label Address 1 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LabelAddress1"
                      className="location_form_input"
                      value={LocMEdit.LCM_LabelAddress1}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Label Address 2 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LabelAddress2"
                      className="location_form_input"
                      value={LocMEdit.LCM_LabelAddress2}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Label Address 3 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LabelAddress3"
                      className="location_form_input"
                      value={LocMEdit.LCM_LabelAddress3}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Label Address 4 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LabelAddress4"
                      className="location_form_input"
                      value={LocMEdit.LCM_LabelAddress4}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">Label Address 5 </label>
                    <input
                      label="Date"
                      locale="en-US"
                      name="LCM_LabelAddress5"
                      className="location_form_input"
                      value={LocMEdit.LCM_LabelAddress5}
                      onChange={handleInput}
                      maxLength={100}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="mb-1">
                    <label className="">
                      Status{" "}
                      <span className="text-danger ">
                        {errors.required.LCM_Status}
                      </span>
                    </label>
                    <div className="location_select-container">
                      <Select
                        classNamePrefix="select"
                        isSearchable={false}
                        name="LCM_Status"
                        options={statusOptions}
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        placeholder="--Select--"
                        onMenuOpen={() => handleSelectOpen("LCM_Status")}
                        onMenuClose={handleSelectClose}
                      />
                      <div className="icon-container_list myList">
                        {isSelectOpen === "LCM_Status" ? (
                          <IoCaretUpOutline />
                        ) : (
                          <IoCaretDownOutline />
                        )}
                      </div>
                    </div>
                    <div className="text-danger ">
                      {errors.other.LCM_Status}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="button-container">
          <button type="submit" onClick={handleUpdate} className="save_btn">
            {" "}
            SAVE{" "}
          </button>
          <button className="reset_btn" onClick={handleCancel}>
            {" "}
            RESET{" "}
          </button>
          <Link
            to={`/dashboard/Locationmasterlist`}
            className="list_btn"
            type="button"
          >
            {" "}
            LIST{" "}
          </Link>
        </div>
      </form>
    </React.Fragment>
  );
}

export default LocationMasterEdit;